export interface ParentOrganization {
  parentOrganizationBC: string;
  parentOrganizationName: string;
}

export interface ClientVertical {
  clientVerticalID: number;
  clientVerticalName: string;
  clientVerticalBC: string;
  isActive: boolean;
}

export interface ClientContactDepartment {
  clientContactDepartmentID: number;
  clientContactDepartmentName: string;
  clientContactDepartmentBC: string;
  isActive: boolean;
}

export interface ClientContactRole {
  clientContactRoleID: number;
  clientContactRoleName: string;
  clientContactRoleBC: string;
  isActive: boolean;
}

export interface ClientContactPhone {
  phoneNumberTypeBC: string;
  phoneNumber: string;
  phoneExtension: string;
  isPrimaryPhone: boolean;
  hasSMSConsent: boolean;
}

export interface ClientContact {
  clientContactUUID?: string;
  firstName: string;
  lastName: string;
  title: string;
  emailAddress: string;
  timeZone: string;
  clientContactDepartmentBC: string;
  clientContactRoleBC: string;
  state?: string;
  phones: ClientContactPhone[];
}

/**
 * A client's member-facing contact info, interpolated into validation
 * messages that tell the member who to call (the `{{clientName}}` /
 * `{{clientNumber}}` placeholders in `errorCodes.256` and
 * `serverError.LOW_CONFIDENCE_ADDRESS`). Served by the transport client
 * service's GET `/{clientBC}/memberContact/{servicePlanID}`.
 */
export interface ClientMemberContact {
  clientBC: string;
  clientName: string;
  phoneNumber: string;
}

export interface ClientAdmin {
  userAccountID: number;
  userFirstName: string;
  userLastName: string;
  emailAddress: string;
  isEmailVerified?: boolean;
}

export interface ClientAddressUse {
  clientAddressUseID: number;
  clientAddressUseName: string;
  clientAddressUseBC: string;
  isActive: boolean;
}

export interface ClientAddress {
  clientAddressUUID?: string;
  addressUseBC: string; // clientAddressUseBC: string;
  contactFirstName: string;
  contactLastName: string;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  stateCode: string;
  zipCode: string;
  county: string;
  state: string;
  latitude?: number;
  longitude?: number;
  placeID?: string;
}

// export interface ClientPurposeCode {
//   clientBC: string;
//   name: string;
//   purposeCodeCategoryBC: string;
// }

// Current state of an entity in the Clients microservice
export enum ClientState {
  active = 'active',
  inactive = 'inactive',
  draft = 'draft',
  deleted = 'deleted',
}

export interface ClientListItem {
  clientID: number;
  clientVerticalID: number;
  clientAbbreviation: string;
  clientLegalName: string;
  effectiveStartDate: string;
  effectiveEndDate: string | null;
  clientBC: string;
  isInternal: boolean;
  createdOnUTC: string;
  createdByUserID: number;
  modifiedOnUTC: string;
  modifiedByUserID: number;
  clientState: string;
  parentOrganizationID: number;
  clientVerticalBC: string;
}

export interface Client {
  clientBC: string;
  parentOrganizationBC?: string;
  clientVerticalBC: string;
  clientAbbreviation: string;
  legalName: string;
  effectiveStartDate?: string;
  effectiveEndDate?: string;
  isInternal?: boolean;
  state?: string;
}

export interface AdminFormData {
  firstName: string;
  lastName: string;
  email: string;
}

export interface ClientSummary {
  clientBC: string;
  clientVerticalBC: string;
  clientAbbreviation: string;
  legalName: string;
  isInternal: boolean;
  parentOrganizationBC: string;
  effectiveStartDate: string;
  effectiveEndDate: string;
  modifiedByUserID: string;
  modifiedDateTimeUTC: string;
  correlationUUID: string;
  state: string;
}

// final say on data model
// https://d388xr74049q2m.cloudfront.net/domains/Clients/services/Client/

/*
Questions about model for onboarding:
-------------------------------------
How does the BC get assigned?
  -- will we let the user pick one but return an error if it is already taken
  -- should we validate it immediately as it is typed or wait until they save everthing
  -- should we give them a fixed number of addresses (e.g. main, billing, etc.)
  -- should we give them a fixed number of phones (e.g. main, billing, etc.)
  -- should we give them a fixed number of contacts
  -- are they required to have a parent organization?
*/
